<template lang="pug">
  .b-customer-reject(data-testid="customer-reject-dialog")
    ._title Отклонить позицию
    ._item {{ item && item.name }}
    ._hint Причина обязательна — дизайнер увидит её в чате. Файлы можно приложить по желанию.
    BaseTextarea(
      inputTestId="customer-reject-reason"
      label="Что не подходит"
      labelOuter
      :value="reason"
      :error="error"
      @input="onReason"
      )
    ._files
      label._attach
        | Приложить файл
        input._file(
          type="file"
          multiple
          data-testid="customer-reject-file-input"
          @change="onFiles"
          )
      span._file-item(v-for="file in files" :key="file.id" data-testid="customer-reject-file")
        | {{ file.name }}
    ._buttons
      Btn(blue data-testid="customer-reject-submit" @click="submit") Отклонить
      Btn(grey data-testid="customer-reject-cancel" @click="$emit('finish', false)") Отмена
</template>

<script>
import BaseTextarea from '@/components/BaseTextarea.vue';
import model from '@/model/specCustomer';
import { apiRun } from '@/model/apiRun';

/**
 * Окно отклонения позиции заказчиком (ТЗ 6.6): причина обязательна, файлы по желанию. Отдельного
 * подтверждения поверх окна не требуется — действие выполняется из формы (ТЗ 6.9).
 *
 * Файлы уходят публичной загрузкой по той же персональной ссылке сразу при выборе (ТЗ 3.3, 4.3):
 * операция отклонения принимает уже загруженные идентификаторы. Ответ сервера — обновлённая
 * спецификация в срезе заказчика, она и возвращается странице. Сгенерировано Claude.
 */
export default {
  name: 'CustomerRejectPopupWrappable',
  components: { BaseTextarea },
  data() {
    return {
      link: null,
      item: null,
      reason: '',
      error: '',
      files: [],
    };
  },
  methods: {
    init(params = {}) {
      this.link = params.link ?? null;
      this.item = params.item ?? null;
    },
    onReason(value) {
      this.reason = value;
      if (value.trim()) this.error = '';
    },
    async onFiles(event) {
      // поле сбрасывается сразу: иначе повторный выбор того же файла не даст события
      const input = event.target;
      const list = Array.from(input.files ?? []);
      input.value = '';
      if (!list.length) return;
      // последовательно, чтобы порядок вложений в событии чата совпал с порядком выбора
      const uploaded = await apiRun(
        () => list.reduce(
          (chain, file) => chain.then((acc) => model.uploadFile(this.link, file)
            .then((result) => [...acc, result])),
          Promise.resolve([]),
        ),
        'Не удалось загрузить файл',
      );
      if (uploaded) this.files = [...this.files, ...uploaded];
    },
    async submit() {
      const reason = this.reason.trim();
      if (!reason) {
        this.error = 'Укажите причину отклонения';
        return;
      }
      const view = await apiRun(
        () => model.reject(this.link, {
          item: this.item?.id,
          reason,
          files: this.files.map((file) => file.id),
        }),
        'Не удалось отклонить позицию',
      );
      if (!view) return;
      this.$emit('finish', view);
    },
  },
};
</script>

<style scoped lang="scss">
.customer-reject {
  width: 520px;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__title {
    font-size: 24px;
    font-weight: 700;
  }

  &__item {
    font-weight: 700;
    font-size: 14px;
  }

  &__hint {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__files {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 14px;
  }

  &__attach {
    color: var(--color-accent);
    font-size: 13px;
    cursor: pointer;
  }

  &__file {
    position: absolute;
    opacity: 0;
    visibility: hidden;
  }

  &__file-item {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__buttons {
    display: flex;
    gap: 12px;
  }
}
</style>
